<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="ch00_fm03_title"></a><a id="page_3"></a><img alt="Image" src="images/f0003-01.jpg"/></p>
<p class="author"><strong>By The Topps Company, Inc.</strong></p>
<p class="subtitle"><strong>Introduction by Art Spiegelman<br/>Afterword by John Pound</strong></p>
<p class="pub"><strong><span class="weblink"><a class="nounder" href="http://www.abramsbooks.com/abrams-comicarts.html" target="_blank">Abrams ComicArts</a></span>, New York</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?99c0a328